function newArrows(){
    function cloneElm(elm, htmlClass) {
        if(elm){
            const div = document.createElement('div')

            let newElm = elm.cloneNode(true)
            elm.style.display = 'none'
            div.classList.add(htmlClass)

            if(elm.parentNode.querySelector(`.${htmlClass}`)){
                elm.parentNode.querySelector(`.${htmlClass}`).append(newElm)
                return
            }
            
            elm.parentNode.append(div)
            elm.parentNode.querySelector(`.${htmlClass}`).append(newElm)
        }
    }

    document.querySelectorAll('.prod-list-group').forEach(group => {
        let prevArrow = group.querySelector('.arrow--prev');
        let nextArrow = group.querySelector('.arrow--next');
        let prodListTitle = group.querySelector('.prod-list-hiperlink')
        let prodListDesc = group.querySelector('.prod-list-titles-subtitle')
        
        const div = document.createElement('div')

        cloneElm(prodListTitle, 'newTitles')
        cloneElm(prodListDesc, 'newTitles')
        
        if (prevArrow) {
            let newArrow = prevArrow.cloneNode(true);
            prevArrow.style.display = 'none';
            div.classList.add('newArrows')
            group.querySelector('.prod-list-titles').append(div); // v3: título é irmão do .prod-list-holder, não pai da seta
            group.querySelector('.prod-list-titles > .newArrows').append(newArrow);

            newArrow.addEventListener('click', () => prevArrow.click());
        }
        
        if (nextArrow) {
            let newArrow = nextArrow.cloneNode(true);
            nextArrow.style.display = 'none';
            group.querySelector('.prod-list-titles > .newArrows').append(newArrow);
        
            newArrow.addEventListener('click', () => nextArrow.click());
        
        }
    })
}

try {
    isReady("product-list", newArrows);
} catch (error) {
    console.log(error);
} 